var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { ItemType } from "../../data";
import { SuperBannerItem, SuperBannerLoader, SuperBannerSportsItem, SuperBannerJackpotItem } from "../../components";
let SuperBannerItems = class SuperBannerItems extends React.PureComponent {
    render() {
        const { items, itemWidth } = this.props;
        return (items.length === 0
            ? React.createElement(SuperBannerLoader, null)
            : items.map((item) => {
                if (item.itemType === ItemType.jackpotItem) {
                    return (React.createElement(SuperBannerItem, { key: item.id, clientHashedClass: item.ClientHashClass, clientHashedAttribute: item.ClientHashAttribute, width: itemWidth },
                        item.isLoading && React.createElement(SuperBannerLoader, null),
                        React.createElement(SuperBannerJackpotItem, Object.assign({}, item))));
                }
                return React.createElement(SuperBannerSportsItem, Object.assign({ key: item.id }, this.props, { item: item }));
            }));
    }
};
SuperBannerItems = __decorate([
    observer
], SuperBannerItems);
export { SuperBannerItems };
//# sourceMappingURL=SuperBannerItems.js.map